import { render, staticRenderFns } from "./ActivityManagePage.vue?vue&type=template&id=f664fd94&scoped=true"
import script from "./ActivityManagePage.vue?vue&type=script&lang=js"
export * from "./ActivityManagePage.vue?vue&type=script&lang=js"
import style0 from "./ActivityManagePage.vue?vue&type=style&index=0&id=f664fd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f664fd94",
  null
  
)

export default component.exports